<template>
  <div id="App">
    <van-nav-bar
      :title="pro.Name"
      :left-text="showReturn ? '返回' : ''"
      :left-arrow="showReturn"
      @click-left="onClickLeft"
      :right-text="showAdd ? '添加班组' : ''"
      @click-right="onClickRight"
    />
    <van-list
      style="margin-top: -15px"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad()"
    >
      <van-divider />
      <van-swipe-cell v-for="item in list" :key="item.CODE">
        <van-cell
          :title="item.NAME"
          :label="'总人数:' + item.ZRS"
          is-link
          size="large"
          @click="onClickCell(item)"
        />
        <template #right>
          <van-button
            square
            type="danger"
            text="修改"
            @click="onClickEditTeam(item)"
          />
        </template>
      </van-swipe-cell>
    </van-list>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Dialog } from "vant";
export default {
  data() {
    return {
      showReturn: true,
      list: [],
      showAdd: true,
      loading: false,
      finished: false,
      pro: {
        Code: "",
        Name: ""
      }
    };
  },
  computed: {
    ...mapState(["userInfo", "tempQuery"])
  },
  methods: {
    getTitle(index) {
      var newDate = new Date(Date.now() - (index - 1) * 24 * 60 * 60 * 1000);
      return newDate.getMonth() + 1 + "/" + newDate.getDate();
    },
    onClickLeft() {
      this.$router.push("/workers");
    },
    onClickCell(key) {
      var that = this;
      that.$store.commit("setTempQuery", {
        Code: key.CODE,
        Name: key.NAME,
        Pro: that.pro
      });
      that.$router.push({
        path: "/SelWorkerList",
        name: "SelWorkerList"
      });
    },
    onClickRight() {
      var that = this;
      that.$store.commit("setTempQuery", {
        Code: getGuid(),
        Name: "",
        Pro: that.pro
      });
      that.$router.push({
        path: "/TeamInfo",
        name: "TeamInfo"
      });
    },
    onClickEditTeam(key) {
      var that = this;
      that.$store.commit("setTempQuery", {
        Code: key.CODE,
        Name: key.NAME,
        Pro: that.pro
      });
      that.$router.push({
        path: "/TeamInfo",
        name: "TeamInfo"
      });
    },
    onLoad() {
      this.loading = true;
      var that = this;
      that.showAdd =
        that.userInfo.loginType == "2" || that.userInfo.loginType == "3" || that.userInfo.loginType == "4";
      that.pro = that.tempQuery;
      that
        .$axios({
          method: "post",
          url: "/api/Main",
          data: {
            Method: "GetWechatTeamList",
            Params: [
              that.userInfo.userCardID,
              that.pro.Code,
              that.userInfo.loginType,
              "1970-01-01",
              that.userInfo.loginType == "0" ? "2" : "1"
            ]
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            if (that.userInfo.loginType == "0") {
              that.$store.commit("setTempQuery", {
                Code: response.data.Table[0].WorkerCode,
                Name: that.userInfo.userName,
                Team: {
                  Code: response.data.Table[0].TeamCode,
                  Name: response.data.Table[0].TeamName,
                  Pro: {
                    Code: that.pro.Code,
                    Name: that.pro.Name
                  }
                }
              });
              that.$router.push({
                path: "/WorkerInfo",
                name: "WorkerInfo"
              });
            } else {
              that.list = response.data.Table;
            }
            that.finished = true;
          } else {
            Dialog({ message: response.data.msg });
            that.finished = true;
          }
        })
        .catch(error => {
          window.console.log(error);
          //弹出失败提醒
          Dialog({ message: error.message });
          that.finished = true;
        });
    }
  }
};
function getGuid() {
  var guid = "";
  for (var i = 1; i <= 32; i++) {
    var flag = Math.floor(Math.random() * 10);
    if (flag % 2 == 0) {
      //全大写
      var n = Math.floor(flag * 2.4) + 65;
      //全小写
      // var n = Math.floor(flag*2.4) + 97;
      n = String.fromCharCode(n);
      guid += n;
    } else {
      guid += flag;
    }
    if (i == 8 || i == 12 || i == 16 || i == 20) guid += "-";
  }
  return guid;
}
</script>
